export const PauseBtnIcon = () => {
  return (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.03208 3C8.14095 3 7.66253 3.67188 7.66253 4.5V13.5C7.66253 14.3281 8.14095 15 9.03208 15C9.92321 15 10.4995 14.3281 10.4995 13.5V4.5C10.4995 3.67188 9.92321 3 9.03208 3Z"
        fill="white"
      />
      <path
        d="M2.86956 3C1.97843 3 1.5 3.67188 1.5 4.5V13.5C1.5 14.3281 1.97843 15 2.86956 15C3.76069 15 4.33694 14.3281 4.33694 13.5V4.5C4.33694 3.67188 3.76069 3 2.86956 3Z"
        fill="white"
      />
    </svg>
  );
};
